import apiClient from './apiClient';

export const anlagenApi = {
  getByKunde: (kundeId) => apiClient.get(`/anlagen/kunde/${kundeId}`),
  create: (data) => apiClient.post('/anlagen', data),
  update: (id, data) => apiClient.put(`/anlagen/${id}`, data),
  delete: (id) => apiClient.delete(`/anlagen/${id}`),

  createWartungsVertrag: (data) => apiClient.post('/anlagen/wartungsvertrag', data),
  updateWartungsVertrag: (id, data) => apiClient.put(`/anlagen/wartungsvertrag/${id}`, data),
  deleteWartungsVertrag: (id) => apiClient.delete(`/anlagen/wartungsvertrag/${id}`),

  getHistorie: (anlageId) => apiClient.get(`/anlagen/${anlageId}/historie`),
  createHistorie: (data) => apiClient.post('/anlagen/historie', data)
};
